var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "car_2_",
    "data-name": "car(2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6357",
    "data-name": "Rectangle 6357",
    width: 36.293,
    height: 27.304,
    fill: "#c8d1ec"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6355",
    "data-name": "Rectangle 6355",
    width: 74,
    height: 74,
    rx: 12,
    fill: "#f1f5ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34956",
    "data-name": "Group 34956",
    transform: "translate(18.853 23.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34956-2",
    "data-name": "Group 34956",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24448",
    "data-name": "Path 24448",
    d: "M0,9.464A3.813,3.813,0,0,1,1.186,7.626,25.746,25.746,0,0,1,7.545,2.7a23.174,23.174,0,0,1,22.311.326,23.8,23.8,0,0,1,5.73,4.583,2.407,2.407,0,0,1,.3,3.032,2.361,2.361,0,0,1-2.828.937,3.071,3.071,0,0,1-1.07-.72,20.553,20.553,0,0,0-4.4-3.548A17.976,17.976,0,0,0,16.081,4.984,17.879,17.879,0,0,0,5.435,10.252c-.385.383-.781.755-1.151,1.154A2.436,2.436,0,0,1,.057,10.3.681.681,0,0,0,0,10.173V9.464",
    transform: "translate(0 0)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24449",
    "data-name": "Path 24449",
    d: "M14.956,3.985a14.519,14.519,0,0,1,7,1.95A15.233,15.233,0,0,1,26.1,9.492a2.62,2.62,0,0,1-3.7,3.627c-.554-.457-1.051-.985-1.587-1.464a8.457,8.457,0,0,0-10.375-.924A11.868,11.868,0,0,0,8.82,12.049c-.545.488-1.027,1.046-1.587,1.515A2.639,2.639,0,0,1,3.528,9.875,15.259,15.259,0,0,1,11.983,4.4c.976-.2,1.981-.28,2.972-.414",
    transform: "translate(3.547 4.737)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24450",
    "data-name": "Path 24450",
    d: "M6.394,12.79a4.238,4.238,0,1,1,4.189,4.29,4.243,4.243,0,0,1-4.189-4.29",
    transform: "translate(7.6 10.222)",
    fill: "#c8d1ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.de78dbc6611d36eb8f95fdb8da56beb7.svg";
export { ForwardRef as ReactComponent };